// extracted by mini-css-extract-plugin
export default {"root":"sponsor-application_root__vyhQb","customDivider":"sponsor-application_customDivider__iYswg"};